import { Pipe, PipeTransform } from '@angular/core';
import { getPageVisibilityFromConfig } from '../_utils/routes.utils';

@Pipe({ name: 'rsGetPageVisibilityFromConfig' })
export class GetPageVisibilityFromConfig implements PipeTransform {
  public transform(config: any, visibilityKey: string = ''): boolean {
    return getPageVisibilityFromConfig(config, visibilityKey);
  }
}
